import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-divider-menu',
  templateUrl: './divider-menu.component.html',
  styleUrls: ['./divider-menu.component.scss']
})
export class DividerMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
